export function uint8ArrayToBase64Url(uint8Array: Uint8Array, start: number, end: number) {
  start = start || 0;
  end = end || uint8Array.byteLength;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const base64 = window.btoa(String.fromCharCode.apply(null, uint8Array.subarray(start, end)));
  return base64.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}

// Converts the URL-safe base64 encoded |base64UrlData| to an Uint8Array buffer.
export function base64UrlToUint8Array(base64UrlData: string) {
  const padding = "=".repeat((4 - (base64UrlData.length % 4)) % 4);
  const base64 = (base64UrlData + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const buffer = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    buffer[i] = rawData.charCodeAt(i);
  }
  return buffer;
}
